export { default } from './FinancialInfoBody';
